<template>
    <MySubscription></MySubscription>
</template>

<script>
    import MySubscription from "../components/MySubscription";

    export default {
        name: "my-subscription",
        components: {
            MySubscription,
        }
    };
</script>